import React,{Fragment} from 'react';
import './index.scss';
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Scrolling,
    Selection
} from 'devextreme-react/data-grid';

export default function archived(){
return(
    <Fragment>
    <h4 className={'content-block'}>Carrier Pickups</h4>
    <div className={'content-block'}>
        <DataGrid></DataGrid>
    </div>
</Fragment>
)
};